import React, { useState } from "react";

const formatInstructorId = (id) => {
  if (!id) return "—";
  return `INS-${id.slice(-6).toUpperCase()}`;
};

const InstructorIdBadge = ({ instructorId }) => {
  const [copied, setCopied] = useState(false);

  if (!instructorId) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(instructorId);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard may be unavailable in some browsers.
    }
  };

  return (
    <div className="mt-1 flex flex-wrap items-center gap-2">
      <span className="text-[10px] font-medium uppercase tracking-wide text-[#089BC4] sm:text-xs">
        Instructor ID
      </span>
      <span className="rounded-full bg-white px-2.5 py-0.5 font-mono text-[11px] text-[#6B6B6B] sm:text-xs">
        {formatInstructorId(instructorId)}
      </span>
      <button
        type="button"
        onClick={handleCopy}
        className="text-[11px] font-medium text-[#089BC4] hover:underline sm:text-xs"
      >
        {copied ? "Copied" : "Copy"}
      </button>
    </div>
  );
};

export default InstructorIdBadge;
